import React from 'react';
import { CheckCircle } from 'lucide-react';
import LoadingSpinner from '../ui/LoadingSpinner';

export default function CompleteConfirmModal({ isOpen, onClose, onConfirm, deliveryName, isProcessing }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div className="p-6 text-center">
          <div className="w-16 h-16 rounded-full bg-status-success-bg flex items-center justify-center mx-auto mb-4">
            <CheckCircle size={32} className="text-status-success" />
          </div>
          <h3 className="text-xl font-semibold text-locate2-dark-blue mb-2">
            {isProcessing ? 'Processing...' : 'Mark as Actioned?'}
          </h3>
          <p className="text-locate2-light-gray">
            {isProcessing ? (
              <>
                Marking the import for{' '}
                <span className="font-medium text-locate2-medium-gray">{deliveryName}</span>{' '}
                as actioned. This may take a moment for large orders.
              </>
            ) : (
              <>
                Are you sure you want to mark the import for{' '}
                <span className="font-medium text-locate2-medium-gray">{deliveryName}</span>{' '}
                as actioned? This indicates it has been manually processed in the third-party
                system.
              </>
            )}
          </p>
        </div>
        <div className="flex gap-3 p-4 border-t border-locate2-border-light">
          <button
            onClick={onClose}
            disabled={isProcessing}
            className="flex-1 px-4 py-2.5 border border-locate2-border rounded-lg text-locate2-medium-gray font-medium hover:bg-locate2-bg-light transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isProcessing}
            className="flex-1 px-4 py-2.5 bg-status-success rounded-lg text-white font-medium hover:bg-status-success-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center gap-2"
          >
            {isProcessing ? (
              <>
                <LoadingSpinner size="sm" className="border-white border-t-transparent" />
                Processing...
              </>
            ) : (
              'Yes, Mark Actioned'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
